var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 59.88 78.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n        opacity: .2;\n      }\n\n      .cls-2, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1269.23,
    y1: 580.56,
    x2: -1267.8,
    y2: 580.2,
    gradientTransform: "translate(67772.92 43170.97) scale(53.86 -74.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2573ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0364ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1276,
    y1: 500.53,
    x2: -1275,
    y2: 500.53,
    gradientTransform: "translate(40711.31 2823.29) scale(32.74 -5.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0063ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2573ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1270.47,
    y1: 577.65,
    x2: -1269.32,
    y2: 577.65,
    gradientTransform: "translate(67768.31 43174.45) scale(53.87 -74.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bdaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59bdef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-1",
    d: "M59.68,30.87L32.95,2.16,6.22,0S1.92,36.24,32.95,74.67c31.02-2.61,26.73-43.8,26.73-43.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-3",
    d: "M6.22,0L.2,3.47l26.73,2.16,6.01-3.47L6.22,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-4",
    d: "M53.66,34.34L26.93,5.64l-10.99-1.11L.2,3.48s-4.3,36.24,26.73,74.67c31.03-2.61,26.73-43.81,26.73-43.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-5",
    d: "M53.66,34.34L26.93,5.64.2,3.48l.76-.44,27.09,2.19,26.73,28.7s3.59,34.44-19.52,42.33c21.88-8.6,18.41-41.92,18.41-41.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-2",
    d: "M50.42,34.78L26.39,8.98l-9.88-1-14.15-.95S-1.51,39.61,26.39,74.17c27.9-2.34,24.03-39.39,24.03-39.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.df2f31ca4dcb1d37ad9d45b3abe1b3c8.svg";
export { ForwardRef as ReactComponent };